var ko = require('knockout');
var _ = require('underscore');

// This code handles the application of knockout view models to DOM elements on
// DOM ready. You defined the view model that you'd like to apply using knockout
// to a given DOM element using one of 2 methods:
//
// 1. Define a view model before DOM ready on the viewModels object and set
// the data-apply-bindings attribute to the property name.
//
//   <script>
//     viewModels['browse-view'] = new Browse.View(...);
//   </script>
//   <div class="families" data-apply-bindings="browse-view">...</div>
//   <div class="filters" data-apply-bindings="browse-view">...</div>
//
// 2. Set the data-apply-bindings attribute to a JSON object to define a one-off
// view model object. A view model will be instantiated with the given property
// names as simple ko.observables with the given initial values, and then applied
// to the element:
//
//   <div class="kit-menu" data-apply-bindings="{ &quot;open&quot;: false }">
//     <a class="kit-menu-button" data-bind="click: function() { open(!open()) }">Kit menu</a>
//     <ul class="kit-menu-list" data-bind="visible: open">...</ul>
//   </div>
var viewModels = {};

var setupFunctions = [];

// Add a setup function to be called just before the view models are applied
// to the bindings on the page. These functions should add view models to the
// viewModels object.
//
// This method should only be called before domReady is fired.
//
// setupFunction - Function to execute just before view models are bound.
//
// Returns nothing.
function viewModelSetup(setupFunction) {
  setupFunctions.push(setupFunction);
}

// Executes all of the setup functions that have been registered.
//
// Returns nothing.
function viewModelExecuteSetups() {
  _.each(setupFunctions, function(setupFunction) { setupFunction(); });
  setupFunctions = [];
}

// Apply the view models to the bindings on the page. First, all elements
// on the page with a data-apply-bindings property are found and the view
// model identified by that property is found or created. Then, knockout is
// used to apply the view model to the bindings on and within that element.
//
// This shouldn't be called until after domReady and after all of the
// necessary view models have been setup.
//
// Returns nothing.
function viewModelApplyBindings() {
  // Apply bindings with newly initialized view models.
  $('*[data-apply-bindings]').each(function() {
    var $scope = $(this);
    var applyBindings = $scope.data('apply-bindings');

    // Get the view model to apply.
    var viewModel;
    if (_.isString(applyBindings)) {
      // Use a named view model instance that has been stored.
      viewModel = viewModels[applyBindings];
    } else {
      // Create a one-off view model with observables.
      viewModel = {};
      _.each(applyBindings, function(value, property) {
        viewModel[property] = ko.observable(value);
      });
    }

    // Remove static markup from any template or templateAnimateSwap bindings
    // with a foreach so knockout can re-render it. Do NOT remove markup from
    // a bare foreach binding since the template content will be inside the
    // element itself.
    $scope.find('*[data-bind]').andSelf().each(function() {
      var $el = $(this);
      var dataBind = $el.attr('data-bind');
      if (dataBind && dataBind.match(/(^|\W)template.*:.*foreach:/)) {
        $el.html('');
      }
    });

    // Apply the model to the scope element
    ko.applyBindings(viewModel, this);
  });
}

function init() {
  // Setup all of the view models with the registered setup functions.
  viewModelExecuteSetups();

  // Apply bindings with the view models we have.
  viewModelApplyBindings();
}

module.exports = {
  init: init,
  viewModelApplyBindings: viewModelApplyBindings,
  viewModelExecuteSetups: viewModelExecuteSetups,
  viewModels: viewModels,
  viewModelSetup: viewModelSetup
};
